import { render, staticRenderFns } from "./意向转出.vue?vue&type=template&id=72240dc5&scoped=true"
import script from "./意向转出.vue?vue&type=script&lang=js"
export * from "./意向转出.vue?vue&type=script&lang=js"
import style0 from "./意向转出.vue?vue&type=style&index=0&id=72240dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72240dc5",
  null
  
)

export default component.exports